import styled from 'styled-components';

export const TableRow = styled.div`
  display: flex;
  justify-content: space-between;

  &:first-of-type {
    margin-block: 0.75rem;
  }

  &:not(:first-of-type) {
    margin-block-end: 0.75rem;
  }
`;

export const Label = styled.span``;

export const TableHeader = styled.h5`
  margin-block-start: 1.5rem;
  margin-block-end: 1rem;
  margin-inline: 0;
  width: 100%;
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  border-block-end: 1px solid ${Styles.color.grey.five};
`;

export const IconList = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.25rem;
`;

export const IconListIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
